<div class="shareContainer">

  <div class="shareModalBox" [ngClass]="{'lowCoins': !hasEnoughCoins, 'highCoins': hasEnoughCoins}">
    <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
    </div>
    <div class="imgDiv">
      <div class="superlike-circle">
        <img class="superlike-logo" [src]="srcIconSuperLike" alt="Super Like" (error)="onImageError($event)">
      </div>
    </div>
    <span class="title-share">{{'superLike' | translate}}</span>

    <div class="txt-description">
      {{ descriptionText }}
    </div>
    <br>
    <ion-button class="boostButton button-round" *ngIf="hasEnoughCoins" (click)="confirmSend()">
      {{'send' | translate}}
    </ion-button>
    <ion-button class="purchaseButton button-round" *ngIf="!hasEnoughCoins" (click)="openCurrency('SuperLike')">
      {{'buyCarrots' | translate}}
    </ion-button>
    <span class="youOwnClass lowCoins" *ngIf="!hasEnoughCoins">
      {{ 'youOwn' | translate }} {{ userData?.coins ?? 0 }} {{ 'carrots' | translate }}
    </span>
  </div>
</div>
